export type direction = 'up' | 'down' | 'left' | 'right';
export const DIRECTION_STYLES: Record<direction, string> = {
  up: 'rotate-0',
  down: 'rotate-180',
  right: 'rotate-90',
  left: '-rotate-90',
};

export interface IconProps {
  className?: string;
  size?: number;
  disabled?: boolean;
  direction?: direction;
}
